import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useToast } from "@kanda-libs/ks-design-library";
import {
  Document,
  services,
  useSubmit,
  Service,
} from "@kanda-libs/ks-frontend-services";
import companySelectors from "store/selectors/company";

export interface InsuranceDocumentButtonPropsHook {
  onClick: () => void;
  isSubmitting: boolean;
}

export default function useInsuranceDocumentButonProps() {
  const company = useSelector(companySelectors.getEntity);
  const { showError } = useToast();

  const { submit: getDocument, isSubmitting } = useSubmit(
    services.document.getDocument as unknown as Service<Document, {}, {}>
  );

  const onClick = useCallback(() => {
    const documentId = company?.company_info?.insurance_document?.id;

    getDocument({ params: { id: documentId as string } }).then(
      ({ data, error }) => {
        if (error) {
          showError("Error fetching document");
          return;
        }
        const a = document.createElement("a");
        const { name, content, mimetype } = data as Document;
        const filename = `insurance_document_${company?.cid}.${
          name?.split(".")?.slice(-1)?.[0]
        }`;
        a.href = `data:${mimetype};base64,${content}`;
        a.download = filename;
        a.click();
        a.remove();
      }
    );
  }, [company, getDocument, showError]);

  return {
    onClick,
    isSubmitting,
  };
}
